import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, spacing, radius, breakpoints, fontSize, sizes } = redesignTheme;

export const useNotificationBannerStyles = makeStyles(() => ({
  mobileSpace: {
    display: 'none',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      display: 'block',
      height: 56,
      flexShrink: 0,
    },
  },
  banner: {
    position: 'fixed',
    right: 0,
    zIndex: 1100,
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
    width: 'fit-content',
    maxWidth: 'calc(100% - 16px)',
    padding: '12px 16px',
    marginTop: 35,
    border: 0,
    borderRadius: `${radius.md}px 0 0 ${radius.md}px`,
    backgroundColor: colors.notification,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    boxSizing: 'border-box',
    transition: 'top 0.2s ease',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      left: spacing.sm,
      right: spacing.sm,
      width: 'auto',
      maxWidth: '100%',
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
      gap: spacing.xs,
      borderRadius: radius.md,
      marginTop: spacing.xs,
      padding: '8px 12px',
    },
  },
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.xs,
    fontSize: fontSize.base,
    fontFamily: fonts.opensansSemiBold,
    whiteSpace: 'nowrap',
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      fontSize: fontSize.md,
    },
  },
  count: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: colors.notificationBadge,
    fontSize: fontSize.md,
    fontFamily: fonts.opensansSemiBold,
  },
  action: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    minHeight: sizes.buttonHeight,
    padding: '0 24px',
    borderRadius: radius.sm,
    backgroundColor: colors.notificationMuted,
    fontSize: fontSize.md,
    fontFamily: fonts.opensansSemiBold,
    letterSpacing: 0.28,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    [`@media (max-width: ${breakpoints.tablet - 1}px)`]: {
      minHeight: 40,
      padding: '0 8px',
    },
  },
  icon: {
    width: 16,
    height: 16,
  },
}));
